// @flow

import { DeliveryTime } from '../atoms';
import {
  Package, Duration, ClaimFree, Mileage, SmallColors,
} from '../../config';
import { KmPrice } from './atoms';

const rows = [
  {
    textKey: 'type',
    Component: Package,
  },
  {
    textKey: 'color',
    Component: SmallColors,
  },
  {
    textKey: 'deliveryTime',
    Component: DeliveryTime,
  },
  {
    textKey: 'duration',
    Component: Duration,
  },
  {
    textKey: 'claimFree',
    Component: ClaimFree,
  },
  {
    textKey: 'kmPack',
    Component: Mileage,
  },
  {
    textKey: 'priceDifferencePerKm',
    Component: KmPrice,
  },
];

export default rows;
